import { html } from 'lit';

export const iconCaret = html`
  <svg
    width="11"
    height="6"
    viewBox="0 0 11 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M9.80469 1.71875L5.83594 5.71875C5.61719 5.90625 5.36719 6 5.11719 6C4.83594 6 4.58594 5.90625 4.39844 5.71875L0.429688 1.71875C0.117188 1.4375 0.0234375 1 0.179688 0.625C0.335938 0.25 0.710938 0 1.11719 0H9.08594C9.49219 0 9.83594 0.25 9.99219 0.625C10.1484 1 10.0859 1.4375 9.80469 1.71875Z"
      fill="currentColor"
    />
  </svg>
`;
